import { omOrderServices } from 'global/Models/omOrderModel';
import { FC, ReactNode } from 'react';
import { GrLocation } from 'react-icons/gr';

interface props {
  route: omOrderServices[number];
  children: ReactNode;
}

const OrderMethodServiceRow: FC<props> = ({ route, children }) => {
  if (route.serviceList && route.serviceList.length === 0)
    return (
      <div className='min-h-full max-w-60'>
        <span className='block pb-1 text-sm'>
          {route.sourceCity} - {route.destCity}
        </span>
        <div className='space-y-2'>
          <div className='flex items-center w-full px-3 py-2 border rounded-md cursor-pointer md:w-fit border-t-error-color hover:border-t-error-color'>
            <p className='text-[14px] font-medium'>در شهر فرستنده یا گیرنده، نمایندگی فعال تیپاکس وجود ندارد.</p>
          </div>
        </div>
      </div>
    );

  // Check if next day service (serviceId 11) is available and has latitude, longitude, and postalCode
  // const nextDayServiceIndex = route.serviceList.findIndex((service) => service.serviceId === 11);
  // if (nextDayServiceIndex !== -1 && latitude && longitude && postalCode && !route.serviceList.some((service) => service.selected)) {
  //   route.serviceList = route.serviceList.map((service, index) => ({
  //     ...service,
  //     selected: index === nextDayServiceIndex,
  //   }));
  // }

  return (
    <div className='flex gap-6 p-2 bg-zinc-100 rounded-xl w-fit'>
      <div className='relative flex flex-col h-auto py-1 min-h-24'>
        <div className='z-10 flex items-start h-full gap-2'>
          <div className='flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full'>
            <GrLocation />
          </div>
          {route.sourceCity}
        </div>
        <div className='z-10 flex items-center gap-2'>
          <div className='flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full'>
            <GrLocation />
          </div>
          {route.destCity}
        </div>
        <div className='absolute top-0 right-0 z-0 flex w-4 h-full py-4'>
          <div className='w-full h-full border-l border-dashed' />
        </div>
      </div>
      {/* <span className='block pb-1 text-sm'>
                    {route.sourceCity} - {route.destCity}
                  </span> */}
      <div className='flex gap-4'>{children}</div>
    </div>
  );
};

export default OrderMethodServiceRow;
